import { useId, type ReactNode } from "react";
import { cn } from "../../utils/cn";
import { Field } from "./Field";

export interface ChoiceOption {
  value: string;
  label: ReactNode;
  disabled?: boolean;
}

interface RadioGroupProps {
  label?: string;
  helper?: string;
  error?: string;
  required?: boolean;
  name?: string;
  value?: string;
  onChange?: (value: string) => void;
  options: ChoiceOption[];
  direction?: "horizontal" | "vertical";
  disabled?: boolean;
}

export function RadioGroup({
  label,
  helper,
  error,
  required,
  name,
  value,
  onChange,
  options,
  direction = "vertical",
  disabled,
}: RadioGroupProps) {
  const autoId = useId();
  const groupName = name ?? `radio-${autoId}`;
  return (
    <Field label={label} helper={helper} error={error} required={required}>
      <div className={cn("space-y-2", direction === "horizontal" && "flex flex-wrap gap-x-6 gap-y-2 space-y-0")}>
        {options.map((option) => (
          <label
            key={option.value}
            className={cn(
              "flex cursor-pointer items-center gap-2 text-sm text-foreground-800",
              (disabled || option.disabled) && "cursor-not-allowed text-foreground-400"
            )}
          >
            <input
              type="radio"
              name={groupName}
              value={option.value}
              checked={value === option.value}
              onChange={() => onChange?.(option.value)}
              disabled={disabled || option.disabled}
              className="h-4 w-4 cursor-pointer accent-primary-600"
            />
            <span>{option.label}</span>
          </label>
        ))}
      </div>
    </Field>
  );
}